// Co-owner form field elements
var ownerContactForm = document.getElementById("owner-account-form");
var coOwnerFirstName = document.getElementById("coOwnerFirstName");
var coOwnerLastName = document.getElementById("coOwnerLastName");
var smsCheckbox = document.getElementById("cbxIsReceiveSMS");
var mobilePhone = document.getElementById("mobile-phone");

if (coOwnerFirstName && coOwnerLastName) {
    Foundation.Abide.defaults.validators["coowner_validator"] = coOwnerValidator;
}

/**
 * Function to determine if Co-owner first and last name are required
 * First and last name are only required if at least one field is filled in
 * Using abide custom validator to leverage abide form validation to show/hide error messages, etc.
 * For additional abide events & methods: https://get.foundation/sites/docs/abide.html
 */
function coOwnerValidator($el) {
    // If fields are both empty or both filled in, fields are valid
    if (coOwnerFirstName.value && coOwnerLastName.value || !coOwnerFirstName.value && !coOwnerLastName.value) {
        coOwnerFirstName.removeAttribute("required");
        coOwnerLastName.removeAttribute("required");
        $($el).on("focusout", function () {
            $(ownerContactForm).foundation("validateForm");
        });
        return true;
    }
    if (!$el.val()) {
        $el.attr("required", true);
        return false;
    }

    return true;
};

if (smsCheckbox) {
    smsCheckbox.addEventListener("change", togglePhoneRequirement);
}

function togglePhoneRequirement() {

    var isChecked = smsCheckbox.checked;

    if (isChecked) {
        mobilePhone.setAttribute("required", "true");
    } else {
        mobilePhone.removeAttribute("required");
        $("#mobilePhoneErrorMsg").hide();
        $(ownerContactForm).foundation("validateForm");
    }
}
